export default {
  root: ({ props }) => ({
    class: [
      'relative',

      // Alignment
      'inline-flex',
      'align-bottom',

      // Size
      'w-5',
      'h-5',

      // Misc
      { 'cursor-pointer': !props.disabled },
      'select-none',
    ],
  }),
  box: ({ props, context, instance }) => ({
    class: [
      // Alignment
      'flex',
      'items-center',
      'justify-center',

      // Size
      'w-5',
      'h-5',

      // Shape
      'rounded',
      'border',

      // Colors
      {
        'border-blue-100 bg-transparent':
          !context.checked && !props.invalid && !instance.$attrs['unselected-bg'],
        'border-0 bg-blue-100': context.checked,
        'bg-blue-100 border-0':
          !context.checked && !props.invalid && instance.$attrs['unselected-bg'],
      },

      // Invalid State
      { 'border-red-500': props.invalid },
      { 'border-2 border-gray-300 bg-transparent': props.disabled },

      // States
      {
        'peer-hover:bg-linear-to-t peer-hover:from-[#D6E9FF] peer-hover:via-[rgba(255,255,255,0.25)] peer-hover:to-[rgba(255,255,255,0.25)]':
          !props.disabled && !context.checked && !props.invalid,
        'peer-hover:bg-primary-600 peer-hover:border-primary-700':
          !props.disabled && context.checked,
        'peer-focus-visible:border-primary-500 peer-focus-visible:ring-2 peer-focus-visible:ring-primary-400/20':
          !props.disabled,
        'cursor-default opacity-60': props.disabled,
      },

      // Transitions
      'transition-colors',
      'duration-200',
    ],
  }),
  input: ({ props }) => ({
    class: [
      'peer',

      // Size
      'w-full ',
      'h-full',

      // Position
      'absolute',
      'top-0 left-0',
      'z-10',

      // Spacing
      'p-0',
      'm-0',

      // Shape
      'opacity-0',
      'rounded',
      'outline-none',

      // Colors
      'text-black',

      // Misc
      'appearance-none',
      { 'cursor-pointer': !props.disabled },
    ],
  }),
  icon: {
    class: [
      // Font
      'text-base leading-none',

      // Size
      'w-3',
      'h-3',

      // Colors
      'text-blue-800 font-bold',

      // Transitions
      'transition-all',
      'duration-200',
    ],
  },
};
